export default interface Category {
    id: number;
    name: string;
    scope: Scopes;
}

export enum Scopes {
    NATIONAL = 1,
    STATAL = 2,
}

export enum DefaultStatalCategoryId {
    SUPERAUTONOMICA = 5,
    PRIMERA_AUTONOMICA = 6,
    SEGUNDA_AUTONOMICA = 7,
}
